// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2FiWe","infoBtn":"quickbooks_infoBtn__10ZH8","formBox":"quickbooks_formBox__2d3aY","formFooter":"quickbooks_formFooter__MRf2m"};